window.locationUtils = function locationUtils() {};

// Get formatted today's date
locationUtils.getDeviceDate = function() {
  var date = new Date();
  return (date.getMonth() + 1).toString() + date.getDate().toString() + date.getFullYear().toString();
};

// Creates the object that gets passed to callback, saved in ls/cookie
locationUtils.createLocObj = function(lat, lng) {
  var info = {
    date: locationUtils.getDeviceDate(),
    pos: {
      coords: {
        lat: lat,
        lng: lng
      }
    }
  };
  // Set cookie
  ls.setItemInObj(ls.cookies.loc, info);
  // console.log(info);
  // Returns just position object
  return info.pos;
};

/**
 * Get device's location
 * Uses's google maps api, rate limited to 2500 calls/day, 50/minute
 * Need to update key before moving to production, or should actually add dev/production keys
 * @param callbacks: {
      success: <method>,
      fail: <method>
    }
 * @returns Function
 * @param pos Object (coords)
*/
locationUtils.getDeviceLocation = function(key, callbacks) {
  // Check if cookie exists
  // Check to see if user has already accessed locator service today
  // Otherwise, check location again, may have moved...
  var lastAccessDate;
  if (ls.getItemFromObj(ls.cookies.loc) !== null) {
    lastAccessDate = ls.getItemFromObj(ls.cookies.loc).date;
  }
  // console.log(locationUtils.getDeviceDate() + '/' + lastAccessDate);
  if (locationUtils.getDeviceDate() === lastAccessDate) {
   /*  console.log('locationUtils.getDeviceLocation, last accessed on: ' + lastAccessDate +
          ', use ' + ls.getItemFromObj(ls.cookies.loc).pos.coords.lat +
          ', ' + ls.getItemFromObj(ls.cookies.loc).pos.coords.lng); */
    // SUCCESS
    if (callbacks.success !== undefined) {
      callbacks.success(ls.getItemFromObj(ls.cookies.loc).pos);
    }
  } else {
    // Reset device access date to now
    // Get
    $.ajax({
      'url': 'https://www.googleapis.com/geolocation/v1/geolocate?key=' + key,
      'type': 'POST',
      'dataType': 'json',
      'contentType': 'application/json; charset=utf-8',
      'cache': false
    }).done(function(data) {
      // console.log('locationUtils.getDeviceLocation, success');
      // SUCCESS
      if (callbacks.success !== undefined) {
        callbacks.success(locationUtils.createLocObj(
          data.location.lat,
          data.location.lng
        ));
      }
    }).fail(function(data) {
      // console.log('locationUtils.getDeviceLocation, fail');
      // console.log(data);
      data = JSON.parse(data.responseText);
      // console.log(data);
      if (data.location === undefined) {
        // FAIL
        // Consider using browser-based here as fallback
        if (callbacks.fail !== undefined) {
          // Very laggy, might need timeout?
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
              // console.log('locationUtils.getDeviceLocation, success (from navigator.geolocation)');
                    // SUCCESS
                    if (callbacks.success !== undefined) {
                callbacks.success(locationUtils.createLocObj(
                  position.coords.latitude,
                  position.coords.longitude
                ));
              }
            });
          } else {
            // Browser doesn't support Geolocation
            callbacks.fail();
          }
        }
      } else {
        // Assume success, idk why 200s throw fail
        // console.log('locationUtils.getDeviceLocation, success (from fail handler)');
        // SUCCESS
        if (callbacks.success !== undefined) {
          callbacks.success(locationUtils.createLocObj(
            data.location.lat,
            data.location.lng
          ));
        }
      }
    });
  }
};
